import { clsx, type ClassValue } from 'clsx';

/**
 * Tiny class-name combinator. We deliberately avoid `tailwind-merge` — the
 * editorial palette is small and we author class strings deterministically;
 * the runtime cost of `tailwind-merge` isn't worth saving on this build.
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
